import axios from "axios";

export const register = async (payload) => {
  try {
    let data = await axios.post(
      `${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/user/register`,
      payload
    );
    return data;
  } catch (err) {
    console.log("error while registering user in  keyclock", err.message);
    return {
      message: "Server Not responding! plese try after some time",
      status: 409,
    };
  }
};
